import React from "react";
import { TenderProcessTableContainer, FileHeader, FileRow, FileName, FileSize } from "./TenderProcessTable.styles";

const TenderProcessTable = ({files}) => {
  return (
    <TenderProcessTableContainer>
      <FileHeader>
        <span>File Name</span>
        <span>File Size</span>
      </FileHeader>
      {files.map((file, index) => (
        <FileRow key={index}>
          <FileName>{file.name}</FileName>
          <FileSize>{file.size}</FileSize>
        </FileRow>
      ))}
    </TenderProcessTableContainer>
  );
};

export default TenderProcessTable;